import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const mediaUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  return url;
};

export const getAdminKey = () => sessionStorage.getItem("sl_admin_key") || "";

export const adminHeaders = () => ({ "X-Admin-Key": getAdminKey() });

export const publicApi = axios.create({ baseURL: API });
